import React, { useState, useRef } from 'react';
import { Card } from 'primereact/card';
import './tech.scss';

import ReactImg from './TechImg/react.png';
import AngularImg from './TechImg/angular.png';
import JsImg from './TechImg/js.jpg';
import PythonImg from './TechImg/python.png';
import FlaskImg from './TechImg/flask.png';
import NodeImg from './TechImg/node.png';
import MongoImg from './TechImg/mongo.png';
import SqlImg from './TechImg/sql.svg';
import JavaImg from './TechImg/java.png';
import SpringBootImg from './TechImg/springboot.png';
import GoImg from './TechImg/go.png';

function Tech() {
  return (
    <div className="tech">
      <div className="title">Technologies I have experience in </div>
      <div className="p-grid p-justify-around card-grid-wrapper">
        <div className="p-xs-6 p-sm-6 p-lg-3 card-wrapper">
          <Card className="card">
            <img src={ReactImg} className="card-img" />
            <div className="card-overlay">React</div>
          </Card>
        </div>
        <div className="p-xs-6 p-sm-6 p-lg-3 card-wrapper">
          <Card className="card">
            <img src={AngularImg} className="card-img" />
            <div className="card-overlay">Angular</div>
          </Card>
        </div>
        <div className="p-xs-6 p-sm-6 p-lg-3 card-wrapper">
          <Card className="card">
            <img src={JsImg} className="card-img" />
            <div className="card-overlay">Javascript</div>
          </Card>
        </div>
        <div className="p-xs-6 p-sm-6 p-lg-3 card-wrapper">
          <Card className="card">
            <img src={PythonImg} className="card-img" />
            <div className="card-overlay">Python</div>
          </Card>
        </div>
        <div className="p-xs-6 p-sm-6 p-lg-3 card-wrapper">
          <Card className="card">
            <img src={FlaskImg} className="card-img" />
            <div className="card-overlay">Flask</div>
          </Card>
        </div>
        <div className="p-xs-6 p-sm-6 p-lg-3 card-wrapper">
          <Card className="card">
            <img src={NodeImg} className="card-img" />
            <div className="card-overlay">Node JS</div>
          </Card>
        </div>
        <div className="p-xs-6 p-sm-6 p-lg-3 card-wrapper">
          <Card className="card">
            <img src={MongoImg} className="card-img" />
            <div className="card-overlay">Mongo DB</div>
          </Card>
        </div>
        <div className="p-xs-6 p-sm-6 p-lg-3 card-wrapper">
          <Card className="card">
            <img src={SqlImg} className="card-img" />
            <div className="card-overlay">SQL</div>
          </Card>
        </div>
        <div className="p-xs-6 p-sm-6 p-lg-3 card-wrapper">
          <Card className="card">
            <img src={JavaImg} className="card-img" />
            <div className="card-overlay">Java</div>
          </Card>
        </div>
        <div className="p-xs-6 p-sm-6 p-lg-3 card-wrapper">
          <Card className="card">
            <img src={SpringBootImg} className="card-img" />
            <div className="card-overlay">Spring Boot</div>
          </Card>
        </div>
        <div className="p-xs-6 p-sm-6 p-lg-3 card-wrapper">
          <Card className="card">
            <img src={GoImg} className="card-img" />
            <div className="card-overlay">Go</div>
          </Card>
        </div>
      </div>
    </div>
  )
}

export default Tech;